"use client";

import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
export default function JoinGreystonesuppliesToday() {
  return <section data-section-id="236605" id="bereit-für-ihr-grünes-event" className="relative w-full overflow-hidden dark bg-primary text-primary-foreground py-20 px-4 sm:py-32">
      {}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 right-10 w-64 h-64 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 left-20 w-72 h-72 bg-white rounded-full blur-3xl"></div>
      </div>

      {}
      <div className="relative z-10 max-w-4xl mx-auto text-center">
        <h2 className="font-default text-4xl sm:text-5xl lg:text-6xl font-bold mb-6 tracking-tighter">
          Bereit für Ihr grünes Event?
        </h2>

        <p className="font-default text-lg sm:text-xl mb-8 text-primary-foreground/90 max-w-2xl mx-auto">
          Mieten, Kaufen und Reinigen aus einer Hand in Kärnten.
        </p>

        {}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Link to="/ContactPage">
            <Button className="bg-white text-primary hover:bg-white/90 px-8 py-3 h-auto text-base font-semibold rounded-full shadow-lg transition-transform hover:scale-105">
              Jetzt Anfrage senden
              <ArrowRight className="w-5 h-5" />
            </Button>
          </Link>
        </div>

        {}
        <div className="mt-16 grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-3xl mx-auto">
          <div className="bg-white/10 backdrop-blur-md rounded-xl p-6 border border-white/20 hover:bg-white/20 transition-all duration-300 transform hover:-translate-y-2">
            <div className="text-3xl mb-2"></div>
            <p className="font-default text-sm font-bold tracking-wide uppercase">Nachhaltig</p>
          </div>
          <div className="bg-white/10 backdrop-blur-md rounded-xl p-6 border border-white/20 hover:bg-white/20 transition-all duration-300 transform hover:-translate-y-2">
            <div className="text-3xl mb-2"></div>
            <p className="font-default text-sm font-bold tracking-wide uppercase">Regionaler Service</p>
          </div>
          <div className="bg-white/10 backdrop-blur-md rounded-xl p-6 border border-white/20 hover:bg-white/20 transition-all duration-300 transform hover:-translate-y-2">
            <div className="text-3xl mb-2"></div>
            <p className="font-default text-sm font-bold tracking-wide uppercase">Einfache Abwicklung</p>
          </div>
        </div>
      </div>
    </section>;
}